// 051 (b) Antecedentes familiares, personales y obstétricos -> Observation por grupo bajo el panel `antecedentes`.
import { leerSiNo } from '../camposSimplesDatos';
import {
  ANTECEDENTES_FAMILIARES_OPCIONES,
  ANTECEDENTES_PERSONALES_OPCIONES,
  CONTADORES_OBSTETRICOS,
  hayAbortos051,
  type EstadoIdentificacion051,
} from '../bloques051IdentificacionDatos';
import { cEntero, cFecha, cMarca, cOpcion, cSiNo, cTexto, LOINC_051, local, Seccion051, type Coding, type Contexto051 } from './base';

const CONTADOR_LOINC: Readonly<Record<string, Coding>> = { gestas: LOINC_051.gestas, partos: LOINC_051.partos, abortos: LOINC_051.abortos };

export function agregarAntecedentes(ctx: Contexto051, e: EstadoIdentificacion051): void {
  const { t } = ctx;
  const s = new Seccion051(ctx, local('antecedentes', 'Antecedentes familiares, personales y obstétricos'));
  const fam = 'formularios.f051.antecedentesFamiliares';
  const per = 'formularios.f051.antecedentesPersonales';
  const obs = 'formularios.f051.antecedentesObstetricos';

  s.grupo(
    local('antecedentes-familiares', t(`${fam}.titulo`)),
    ANTECEDENTES_FAMILIARES_OPCIONES.map((c) => cSiNo(local(`familiar-${c}`, t(`${fam}.opciones.${c}`)), leerSiNo(e.antecedentesFamiliares.presentes[c])))
  );

  const p = e.antecedentesPersonales;
  const otraSi = leerSiNo(e.antecedentesFamiliares.presentes.otraCondicionGrave) === 'si' || leerSiNo(p.presentes.otraCondicionGrave) === 'si';
  const diabetesSi = leerSiNo(p.presentes.diabetes) === 'si';
  s.grupo(local('antecedentes-personales', t(`${per}.titulo`)), [
    ...ANTECEDENTES_PERSONALES_OPCIONES.map((c) => cSiNo(local(`personal-${c}`, t(`${per}.opciones.${c}`)), leerSiNo(p.presentes[c]))),
    // Sin hijos huérfanos: el tipo de diabetes y el "cuál" solo si su padre está en Sí.
    diabetesSi ? cOpcion(local('personal-diabetes-tipo', t(`${per}.diabetesTipo`)), p.diabetesTipo, p.diabetesTipo ? t(`${per}.diabetesTipoOpciones.${p.diabetesTipo}`) : '') : undefined,
    otraSi ? cTexto(local('personal-otra-condicion-cual', t(`${per}.otraCual`)), p.otraCual) : undefined,
  ]);

  const o = e.antecedentesObstetricos;
  s.grupo(local('antecedentes-obstetricos', 'Antecedentes obstétricos'), [
    ...CONTADORES_OBSTETRICOS.map((c) => cEntero(CONTADOR_LOINC[c] ?? local(`obstetrico-${c}`, t(`${obs}.${c}`)), o[c])),
    hayAbortos051(o) ? cMarca(local('obstetrico-tres-espontaneos-consecutivos', t(`${obs}.tresEspontaneosConsecutivos`)), o.tresEspontaneosConsecutivos) : undefined,
    cFecha(LOINC_051.fum, o.fechaUltimaMenstruacion),
    cFecha(LOINC_051.fpp, o.fechaProbableParto),
    cOpcion(local('obstetrico-ultimo-embarazo', t(`${obs}.ultimoEmbarazo`)), o.ultimoEmbarazo, o.ultimoEmbarazo ? t(`${obs}.ultimoEmbarazoOpciones.${o.ultimoEmbarazo}`) : ''),
    cSiNo(local('obstetrico-embarazos-multiples', t(`${obs}.embarazosMultiples`)), o.embarazosMultiples),
    cOpcion(local('obstetrico-fin-embarazo-anterior', t(`${obs}.finEmbarazoAnterior`)), o.finEmbarazoAnterior, o.finEmbarazoAnterior ? t(`${obs}.finEmbarazoAnteriorOpciones.${o.finEmbarazoAnterior}`) : ''),
    // "n/a" = no hubo embarazo anterior: una fecha suelta quedaría huérfana.
    o.finEmbarazoAnterior === 'noAplica' ? undefined : cFecha(local('obstetrico-fin-embarazo-anterior-fecha', t(`${obs}.finEmbarazoAnteriorFecha`)), o.finEmbarazoAnteriorFecha),
    cSiNo(local('obstetrico-embarazo-planificado', t(`${obs}.embarazoPlanificado`)), o.embarazoPlanificado),
    cOpcion(local('obstetrico-fracaso-metodo-anticonceptivo', t(`${obs}.fracasoMetodoAnticonceptivo`)), o.fracasoMetodoAnticonceptivo, o.fracasoMetodoAnticonceptivo ? t(`${obs}.fracasoMetodoAnticonceptivoOpciones.${o.fracasoMetodoAnticonceptivo}`) : ''),
  ]);

  s.cerrar();
}
